import React from 'react'
import PageHeader from '../components/PageHeader'

import PageContent from '../components/PageContent'
import Blog from '../components/Blog'



function Events(props) {
  const nss=[
`<div>
  <p >NSS helps the student to grow individually and also as a group. It makes the students confident, develop leadership skills, and gain knowledge about different people from different walks of life. Students also learn other skills that help them lead a better life in various situations.</p></div>`,
'https://campus.acetians.in/custom/images/nss1.png',
[
   
'https://campus.acetians.in/custom/images/nssimg1.jpg',
'https://campus.acetians.in/custom/images/nssimg2.jpg',
'https://campus.acetians.in/custom/images/nssimg3.jpg',
'https://campus.acetians.in/custom/images/nssimg4.jpg',
'https://campus.acetians.in/custom/images/nssimg5.jpg',
'https://campus.acetians.in/custom/images/nssimg6.jpg',
'https://campus.acetians.in/custom/images/nssimg7.jpg',
'https://campus.acetians.in/custom/images/nssimg8.jpg',
'https://campus.acetians.in/custom/images/nssimg9.jpg',
'https://campus.acetians.in/custom/images/nssimg10.jpg',
'https://campus.acetians.in/custom/images/nssimg11.jpg',
'https://campus.acetians.in/custom/images/nssimg12.jpg',
'https://campus.acetians.in/custom/images/nssimg13.jpg'
]
]; 

const roverRanger=[`
<div className="">
       <p >Rovers Rangers is a unit of The Bharat Scouts and Guides. The Bharat Scouts & Guides is a voluntary, non-political, educational movement for young people, open to all without distinction of origin, race or creed ,in accordance with the purpose, principles and methods conceived by the Founder Lord Baden Powell in 1907.</p> 
    </div>
`,
'https://campus.acetians.in/custom/images/rover1.png',
[
]
];

const greenGlob=[`
<div className="">
     <p style="">Green Globe Club is an integral part of our college and all the students who join the college
become a member of this club by default.</p>
<h3 style="">Its Purpose or Objectives</h3>
 <p style="">Green Globe Club play an important role in creating environmental <br> awareness in the college
and motivates to be conscious about the environment where we can live and breathe freely.
Few of its main objectives are:</p>
<ul style="">
    <li style="">Encourage Organic method of farming</li>
    <li style="">Organize tree plantation programmes</li>
    <li style="">Promote conservation of water</li>
    <li style="">Switching to renewable energy sources for our energy need</li>
    <li style="">Promote minimum waste generation, source separation of waste and its proper disposal</li>
    <li style="">Spreading awareness for conservation of the biodiversity.</li>
</ul>
<h2 style="">Its Volunteers-</h2>
<p style="">All the students and alumni of the college.</p>
<h2 style="">Activities-</h2>
<ul style="">
    <li style="">Tree Plantation Drive: They have already planted hundreds of trees in college premises and around the college.</li>
</ul>
<p style=""></p>

<ul >
    <li >Tagging Of Plants: They are effectively tagging plants so that students get the idea of its name and identification</li>
</ul>
<p style=""></p>

<ul style="">
    <li style="">Renewable Energy: Installed solar panels for generating electricity.</li>
</ul>
<p style=""></p>

<ul style="">
    <li style="">Water Harvesting System: The college has three units of water harvesting system for water conservation.</li>
</ul>
<p style=""></p>

<ul style="">
    <li style="">Built Bird Houses, Bird Bath &amp; Bird Feeder: They have installed several bird houses to provide a safe shelter for birds to build their nest, a
protective cover from the weather and predators.</li>
</ul>
<p style=""></p>


<ul style="">
    <li style="">Butterfly Garden: They are developing a beautiful butterfly garden to conserve butterflies and help perpetuate
native plant species</li>
</ul>
<p style=""></p>


<ul style="">
    <li style="">Honeybee Farming Initiative: Beekeeping is a low investment &amp; skill industry having the potential to offer direct
employment to lakhs of unemployed youth &amp; farmers</li>
</ul>
<p style=""></p>


    </div>
`,
'https://campus.acetians.in/custom/images/green-globe.png',
[
 'https://campus.acetians.in/custom/images/greenglobe1.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe2.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe3.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe4.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe5.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe6.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe7.jpg' ,
'https://campus.acetians.in/custom/images/greenglobe8.jpg' ,

]
];
const games=[`
<p>
The life of a student is nothing less than a rollercoaster. A student has a lot to manage in terms of assignments, hands-on activities, examinations, internships, workshops, lectures, and much more, all of which are necessary to ensure the best possible academic progress. This is in addition to acquiring new skills and exploring other possibilities. Finding a break to rejuvenate oneself is crucial in the midst of a busy schedule. Extracurricular activities are really important in this situation. These activities help you keep positive, energized, and cheerful while in college and greatly increase your productivity. They not only make you feel better, but they also help in developing your general personality and capacity for social interaction. We strongly believe in the value of extracurricular activities and encourage our students to participate in a variety of them. The school features a variety of sporting facilities to support a well-rounded learning environment. The sport is no longer seen solely as a fitness exercise. It develops discipline, confidence, team spirit, and accountability in addition to physical strength. With this in mind, athletic activities are a priority in our college, with dedicated teams competing in inter-college and intra-college contests. We have always encouraged students to follow their own passions. We have a 400-meter athletic turf track, a football ground, a cricket ground, tennis, basketball, volleyball and badminton facilities.Indoor activities such as table tennis, chess, and carrom are also available on the campus.</p>
`,
'https://campus.acetians.in/custom/images/sport1.jpg',
[]

];
const images=props.title.includes('Games')?games[2]:props.title.includes('NSS')?nss[2]:props.title.includes('Green')?greenGlob[2]:   roverRanger[2];
  return (
    <div>
      <PageHeader title={props.title} />
      <PageContent elem={<Blog image={props.title.includes('Games')?games[1]:props.title.includes('NSS')?nss[1]:props.title.includes('Green')?greenGlob[1]:   roverRanger[1]} content={props.title.includes('Games')?games[0]:props.title.includes('NSS')?nss[0]:props.title.includes('Green')?greenGlob[0]:   roverRanger[0]}  />}/>
      <div className='container'>
        <div className='row col-md-12  d-flex'>
        {images?.map((i)=>(
            <div className='col-md-3'>
                <div style={{padding:'10px'}}>
                 <a href={i} target='_blank' rel='noreferrer'>
                    <img style={{width:'100%',maxHeight:'300px'}} alt='jpg' src={i}/>
                 </a>
                
                </div>
            </div>
        ))}
        </div>
      </div>
     
    </div>
  )
}

export default Events
